import type React from "react";
import { FluentProvider, createDarkTheme, createLightTheme } from "@fluentui/react-components";
import { useAtomValue } from "jotai";
import { darkModeAtom, isRTLAtom } from "../store";

export const ThemeProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const darkMode = useAtomValue(darkModeAtom);
  const isRTL = useAtomValue(isRTLAtom);
  const customGreenPalette = {
    10: "#030401",
    20: "#171B0B",
    30: "#242D10",
    40: "#2D3A12",
    50: "#374814",
    60: "#415614",
    70: "#4B6415",
    80: "#557215",
    90: "#5F8114",
    100: "#6A9112",
    110: "#74A00E",
    120: "#7FB008",
    130: "#8AC000",
    140: "#A3CD4A",
    150: "#BBD978",
    160: "#D2E5A3",
  };
  const theme = darkMode
    ? createDarkTheme(customGreenPalette)
    : createLightTheme(customGreenPalette);

  return (
    <FluentProvider theme={theme} dir={isRTL ? "rtl" : "ltr"}>
      {children}
    </FluentProvider>
  );
};
